import getSelectSizeStyles from "@/lib/helpers/getSelectSizeStyles";
import useFocus from "@/lib/hooks/interactions/other/useFocus";
import { AlertColorType, ButtonSizeType } from "@/lib/main";
import { CSSProperties, PropsWithChildren } from "react";
import formStyle from "./formStyle.shared";

type Props = PropsWithChildren<{
  onClick?: () => void;
  value: string;
  disabled?: boolean;
  alertColor?: AlertColorType;
  size?: ButtonSizeType;
  selectRef: React.RefObject<HTMLSpanElement | null>;
}>;

export default function Select({
  children,
  onClick,
  value,
  disabled,
  alertColor,
  size,
  selectRef,
}: Props) {
  const { isFocused, onFocus, onBlur } = useFocus();
  const { height, padding, fontSize } = getSelectSizeStyles(size);

  const sharedStyle = formStyle({ value, isFocused, alertColor, disabled });
  const styles: CSSProperties = {
    ...sharedStyle,

    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    height,
    padding,

    fontSize,

    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };

  return (
    <span
      role="select"
      onClick={onClick}
      onFocus={onFocus}
      onBlur={onBlur}
      ref={selectRef}
      style={styles}
    >
      {children}
    </span>
  );
}
